import React from 'react'
import Popup from '../utils/popup'
import ConditionallyRender from '../utils/conditionally-render'
import { GatsbyImage } from 'gatsby-plugin-image'

export default function FaqCard({ faq, open, setOpen }) {
    const callToAction = faq.callToAction[0]
    return (
        <div className='flex left-gradient-image  p-[20px] pl-[25px] bg-[#2B2B2B]' style={{ backgroundImage: `url(${faq.gradient.url})` }}>
            <div className='flex flex-col justify-between'>
                <h3 className='mb-[70px]'>{faq.name}</h3>
                <div>
                    <button onClick={() => setOpen(faq.link)} className='link bg-[#434343]'>
                        {faq.direction}
                    </button>
                </div>
            </div>
            <Popup open={open} setOpen={setOpen} gradient={faq.gradient}  >
                <div className='grid grid-cols-2 md:grid-cols-1'>
                    <div>
                        <h3 className='mb-[80px] md:mb-[50px] md:pr-[25px]'>{faq.name}</h3>
                        <p dangerouslySetInnerHTML={{ __html: faq.description.replaceAll('\n', '<br/>') }} className='max-w-500 links-paragraph'></p>
                        <ConditionallyRender when={(callToAction !== undefined)}>
                            <div className='mt-[90px]  md:mt-[20px]'>
                                <a target="_blank" rel='noreferrer' href={callToAction?.url} className='link bg-[#434343] '>
                                    {callToAction?.text}
                                </a>
                            </div>
                        </ConditionallyRender>
                    </div>
                    <div className='pl-[120px] md:pl-[0px] md:mt-[70px] '>
                        <GatsbyImage image={faq.featureImage?.gatsbyImageData}/>
                    </div>
                </div>

            </Popup>
        </div>

    )
}
